/* global $ */

import Splide from '@splidejs/splide';
import { Video } from '@splidejs/splide-extension-video';

$(document).on('page:load DOMContentLoaded', () => {
  if (!$('#main-carousel').length || !$('#thumbnail-carousel').length) {
    return;
  }

  const startIndex = $('#main-carousel').data('start-index') || 0;
  const imageQtty = $('#thumbnail-carousel .splide__slide').length;

  const mainCarousel = new Splide('#main-carousel', {
    type: 'fade',
    rewind: true,
    pagination: false,
    arrows: imageQtty > 1,
    width: '100%',
    height: '100%',
    start: startIndex,
    perPage: 1,
    video: { volume: 0.5 },
  });

  // Lazy load zoom image and set download buttons to current item.
  mainCarousel.on('active', (slide) => {
    const $zoomImage = $(slide.slide).find('.placeholder img');
    const src = $zoomImage.data('src');
    $zoomImage.attr('src', src);

    const $downloadable = $(slide.slide).find('.downloadable');
    $('.download-picture.normal a').attr('href', $downloadable.data('downloadUrl'));
    $('.download-picture.high_res a').attr('href', $downloadable.data('highResDownloadUrl'));
  });

  const thumbsCarousel = new Splide('#thumbnail-carousel', {
    fixedWidth: 100,
    fixedHeight: 80,
    gap: 0,
    rewind: true,
    pagination: false,
    isNavigation: true,
    height: '100%',
    direction: 'ttb',
    arrows: false,
    start: startIndex,
    breakpoints: {
      992: {
        direction: 'ltr',
        height: 'auto',
        width: '100%',
        fixedWidth: 80,
        fixedHeight: 60,
      },
    },
  });

  mainCarousel.sync(thumbsCarousel);
  mainCarousel.mount({ Video });
  thumbsCarousel.mount();
});
